// import { AuthCard } from '@daveyplate/better-auth-ui'

import { useMemo } from 'react'

import { config } from '@/config/config'
import Store from '@repo/datalayer/store/models/Store'
import ApiProvider, {
  ApiClient,
} from '@repo/datalayer/store/providers/ApiProvider'
import { LogOutIcon, UserCogIcon } from 'lucide-react'
import { Toaster } from 'react-hot-toast'
import { Logo } from '../components/Logo'
import { useRouter } from '../hooks/router'
import { StoreContext } from '../hooks/store'
import { MobxRouter } from './MobxRouter'
import { authClient, useSession } from '@/auth'
import { LoginScreen } from '@/components/auth/LoginScreen'

function AuthedEntrypoint() {
  const session = useSession()
  const store = useMemo(() => {
    const apiClient = new ApiClient(
      config.apiEndpoint,
      async () => session.data?.session.token ?? null
    )
    const provider = new ApiProvider(apiClient)
    const store = new Store(provider)
    return store
  }, [session])

  const router = useRouter()

  return (
    <StoreContext.Provider value={store}>
      <div className="h-screen flex flex-col w-full pt-20">
        <header className="z-50 fixed top-0 left-0 w-full bg-background/80 backdrop-blur-md border-b border-border/50">
          <div className="flex flex-row items-center justify-between max-w-[1320px] mx-auto">
            <div
              className="p-4 cursor-pointer"
              onClick={() => {
                window.location.href = '/'
              }}
            >
              <Logo variant="full" className="h-8" />
            </div>
            <div className="p-4 flex flex-row items-center gap-2">
              <a
                href="/settings"
                data-test-id="settings-link"
                onClick={(e) => {
                  if (e.metaKey || e.ctrlKey) return
                  e.preventDefault()
                  router.navigateToSettings()
                }}
                className="p-2 rounded-lg text-muted-foreground hover:text-foreground hover:bg-muted transition-all"
              >
                <UserCogIcon className="w-5 h-5" />
              </a>
              <a
                href="#"
                data-test-id="logout-button"
                onClick={(e) => {
                  e.preventDefault()
                  authClient.signOut()
                }}
                className="p-2 rounded-lg text-muted-foreground hover:text-foreground hover:bg-muted transition-all"
              >
                <LogOutIcon className="w-5 h-5" />
              </a>
            </div>
          </div>
        </header>
        <MobxRouter store={router} />
      </div>
    </StoreContext.Provider>
  )
}

function UnauthedEntrypoint() {
  return <LoginScreen />
}

function FullScreenLoader() {
  return (
    <div className="flex flex-col items-center justify-center h-screen gap-4">
      <Logo variant="icon" className="h-10 w-10 animate-pulse rounded-xl" />
      <p className="text-muted-foreground">Loading...</p>
    </div>
  )
}

export function Entrypoint() {
  const session = useSession()
  const router = useRouter()
  const isAuth = router.router.currentPath.match('auth/')

  if (session.isPending) return <FullScreenLoader />

  if (isAuth) {
    return <MobxRouter store={router} />
  }

  return session.data ? <AuthedEntrypoint /> : <UnauthedEntrypoint />
}

// function NavLink({
//   href,
//   children,
// }: {
//   href: string
//   children: React.ReactNode
// }) {
//   const router = useRouter()
//   return (
//     <a
//       href={href}
//       onClick={(e) => {
//         if (e.metaKey || e.ctrlKey) return
//         e.preventDefault()
//         router.navigateToUrl(href)
//       }}
//     >
//       {children}
//     </a>
//   )
// }

// function Entrypoint() {
//   const router = useRouter()
//   return <EntrypointInner />
// }

export default Entrypoint
